import { createContext, useContext } from 'react';

var noop = function noop() {};

var leftSidebarState = {
  isFlyoutOpen: false,
  isResizing: false,
  isLeftSidebarCollapsed: false,
  leftSidebarWidth: 0,
  lastLeftSidebarWidth: 0
};
export var SidebarResizeContext = /*#__PURE__*/createContext({
  isLeftSidebarCollapsed: false,
  expandLeftSidebar: noop,
  collapseLeftSidebar: noop,
  leftSidebarState: leftSidebarState,
  setLeftSidebarState: noop
});
export var usePageLayoutResize = function usePageLayoutResize() {
  return useContext(SidebarResizeContext);
};